import React from 'react';
import {Dialog} from "primereact/dialog";
import {jsPDF} from "jspdf";
import {Toast} from 'primereact/toast';

class MapCapture extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            mapElement: null,
            capturedImage: null,
            loading: false
        };

        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const day = String(now.getDate()).padStart(2, '0');
        this.imageName = `mapa-captura-${year}-${month}-${day}.jpeg`;
    }

    componentDidMount() {
        console.log('Mapa captura montada');
    }

    copyToClipboard = async () => {

        // ClipboardItem / navigator.clipboard.write só existem em contexto seguro
        // (HTTPS ou localhost). Em http simples ficam indefinidos — degrada com aviso.
        if (typeof ClipboardItem === 'undefined' || !(navigator.clipboard && navigator.clipboard.write)) {
            this.toast.show({
                severity: 'warn',
                summary: 'Copiar Imagem',
                detail: 'Cópia para a área de transferência indisponível neste navegador/contexto (requer HTTPS). Use os botões JPEG ou PDF.',
                life: 5000,
            });
            return;
        }

        try {
            this.setState({ loading: true });

            await this.props.canvas.toBlob(async (blob) => {
                try {
                    const item = new ClipboardItem({'image/png': blob});
                    await navigator.clipboard.write([item]);
                    console.log("O mapa foi copiado para a área de transferência.");
                    this.toast.show({severity: 'success', summary: 'Copiar Imagem', detail: 'Imagem copiada para a área de transferência!', life: 3000});
                } catch (e) {
                    console.log(e);
                    this.toast.show({severity: 'error', summary: 'Copiar Imagem', detail: 'Não foi possível copiar a imagem.', life: 4000});
                } finally {
                    this.setState({ loading: false });
                }
            }, 'image/png', 2.0);
        } catch (e) {
            console.log(e);
            this.setState({ loading: false });
        }
    }

    downloadPDF = async () => {

        return new Promise((resolve, reject) => {
            try {
                const canvas = this.props.canvas;

                const pdf = new jsPDF({
                    orientation: 'landscape',
                    unit: 'mm',
                    format: 'a4'
                });

                const pageWidth = pdf.internal.pageSize.getWidth();
                const pageHeight = pdf.internal.pageSize.getHeight();

                let imgWidth = pageWidth;
                let imgHeight = (canvas.height * imgWidth) / canvas.width;

                // Se a altura extrapolar, ajusta pela altura
                if (imgHeight > pageHeight) {
                    const ratio = pageHeight / imgHeight;
                    imgWidth *= ratio;
                    imgHeight *= ratio;
                }

                const x = (pageWidth - imgWidth) / 2;
                const y = (pageHeight - imgHeight) / 2;

                pdf.addImage(this.props.imageData, 'JPG', x, y, imgWidth, imgHeight);

                const now = new Date();
                const year = now.getFullYear();
                const month = String(now.getMonth() + 1).padStart(2, '0');
                const day = String(now.getDate()).padStart(2, '0');

                const fileName = `mapa-captura-${year}-${month}-${day}.pdf`;

                resolve(pdf.save(fileName));

            } catch (error) {
                console.error("Erro ao baixar o PDF:", error);
                reject(error);
            }
        })

    }

    render() {
        return (

            <React.Fragment>
                <Toast ref={(el) => this.toast = el} position="bottom-right"/>

                <Dialog
                    header="Salvar Mapa"
                    visible={this.props.visible}
                    style={{width: '60vw', marginTop: '30px'}}
                    onHide={this.props.handleClose}
                    blockScroll={true}
                >
                    <div className="card" style={{paddingBottom: '0', marginBottom: '0'}}>
                        <div className="card-body" id="capture-map-container">
                            {/* `contain`, e não `cover`: com `cover` a imagem era recortada nas
                                bordas para preencher a caixa, escondendo no preview o que está
                                encostado nas margens da captura (a legenda dos polos, no canto
                                inferior esquerdo) — embora o JPEG/PDF baixados a contivessem.
                                Assim o preview mostra exatamente o que é exportado. */}
                            <img alt="Mapa" src={this.props.imageData} style={{
                                width: '100%',
                                height: '70vh',
                                objectFit: 'contain'
                            }}/>
                        </div>
                        <div className="card-footer" style={{paddingBottom: '0'}}>
                            <div className="d-flex justify-content-end align-items-end" style={{gap: '10px'}}>
                                <button disabled={this.state.loading} className="btn btn-rect btn-danger"
                                        onClick={async (e)=>{
                                            await this.setState({ loading: true });
                                            setTimeout(() => {
                                                this.downloadPDF().finally(() => {
                                                    this.setState({ loading: false });
                                                });
                                            }, 100);
                                        }}
                                >PDF &nbsp;{this.state.loading &&
                                    <i className="fas fa-spinner fa-spin"></i>}
                                </button>
                                <a href={this.props.imageData} download={this.imageName}
                                   className="btn btn-rect btn-info">JPEG &nbsp;{this.state.loading &&
                                    <i className="fas fa-spinner fa-spin"></i>}</a>
                                <button disabled={this.state.loading}
                                        onClick={this.copyToClipboard}
                                        className="btn btn-rect btn-default">COPIAR &nbsp;{this.state.loading &&
                                    <i className="fas fa-spinner fa-spin"></i>}</button>
                            </div>
                        </div>
                    </div>
                </Dialog>
            </React.Fragment>
        );
    }
}

export default MapCapture;
